<template>
  <div class="m-footer">
    <div class="line flex-between">
      <img src="../../assets/img/mobile/logo.svg" alt />
      <el-select v-model="lang" placeholder="Choose language" class="lang" size="small" @change="changeLang">
        <el-option label="简体中文" value="zh"></el-option>
        <!-- <el-option label="日本語" value="ja"></el-option> -->
        <el-option label="English" value="en"></el-option>
      </el-select>
    </div>
    <p class="tip">{{ $t("footer.txt") }}</p>
    <div class="link">
      <h3>{{ $t("footer.linkTitle") }}</h3>
      <ul>
        <li v-for="item in web" :key="item.url" @click="open(item.url)">
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import locale from "element-ui/lib/locale"; //locale兼容
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import jaLocale from "element-ui/lib/locale/lang/ja";
export default {
  data() {
    return {
      lang:
        localStorage.getItem("BLOCK_LANG") || process.env.VUE_APP_DEFAULT_LANG,
    };
  },
  computed: {
    web() {
      return [
        {
          title: this.$t("footer.bty"),
          url: "https://www.bityuan.com/",
        },
        {
          title: "X",
          url: "https://x.com/Bityuanofficial",
        },
        {
          title: "Telegram",
          url: "https://t.me/bityuanblockchain",
        },
        {
          title: "Discord",
          url: "https://discord.com/invite/P3gbgSbdg5",
        },
      ];
    },
  },
  methods: {
    open(url) {
      window.open(url);
    },
    changeLang(lang) {
      localStorage.setItem("BLOCK_LANG", lang);
      this.$i18n.locale = lang;
      switch (lang) {
        case "zh":
          locale.use(zhLocale);
          break;
        case "ja":
          locale.use(jaLocale);
          break;
        case "en":
          locale.use(enLocale);
          break;
        default:
          locale.use(zhLocale);
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.m-footer {
  height: 205px;
  background: $white;
  padding: 20px;

  .lang-btn {
    width: 100px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: $white;
    background: rgba(194, 199, 222, 1);
    border-radius: 15px;
  }

  .tip {
    margin: 20px 0 30px;
    font-size: 12px;
    font-family: PingFangSC;
    font-weight: 400;
    color: $grey_deep;
    line-height: 17px;
  }

  .lang {
    width: 115px;

    input {
      // height: 30px;
      background: rgba(194, 199, 222, 1);
      border-radius: 15px;
      color: #fff;
      border: none;
    }

    .el-select__caret {
      color: #fff !important;
    }
  }

  .link {
    h3 {
      font-size: 14px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: $black;
      line-height: 20px;
    }

    ul {
      margin-top: 20px;
      column-count: 3;

      li {
        font-size: 12px;
        font-family: PingFangSC;
        font-weight: 400;
        color: $font_grey;
        line-height: 35px;
      }
    }
  }
}
</style>